import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { 
  IRendererPool, 
  SituAnalyticsWebApiClient, 
  CreateRendererPoolRequest, 
  UpdateRendererPoolRequest
} from 'situanalytics-webapi-client';
import { MatSnackBar } from '@angular/material/snack-bar';

export interface RendererPoolDialogData {
  pool?: IRendererPool;
  isNew: boolean;
}

@Component({
  selector: 'app-renderer-pool-dialog',
  templateUrl: './renderer-pool-dialog.component.html',
  styleUrls: ['./renderer-pool-dialog.component.scss']
})
export class RendererPoolDialogComponent implements OnInit {
  form: FormGroup;
  loading = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: RendererPoolDialogData,
    private dialogRef: MatDialogRef<RendererPoolDialogComponent>,
    private fb: FormBuilder,
    private analyticsApi: SituAnalyticsWebApiClient,
    private snackBar: MatSnackBar
  ) {
    this.form = this.fb.group({
      name: [data.pool?.name || '', [Validators.required]]
    });
  }

  ngOnInit(): void {
  }

  save(): void {
    if (this.form.invalid || this.loading) return;

    this.loading = true;
    const formValue = this.form.value;

    if (this.data.isNew) {
      const request = new CreateRendererPoolRequest();
      request.name = formValue.name;

      this.analyticsApi.createRendererPool(request)
        .then(response => {
          if (response.success) {
            this.showMessage('Renderer pool created successfully');
            this.dialogRef.close(response.rendererPool);
          } else {
            this.showMessage('Failed to create renderer pool');
          }
        })
        .catch(error => {
          console.error('Error creating renderer pool:', error);
          this.showMessage('Error creating renderer pool');
        })
        .finally(() => {
          this.loading = false;
        });
    } else {
      const request = new UpdateRendererPoolRequest();
      request.id = this.data.pool!.id;
      request.name = formValue.name;

      this.analyticsApi.updateRendererPool(request)
        .then(response => {
          if (response.success) {
            this.showMessage('Renderer pool updated successfully');
            this.dialogRef.close(response.rendererPool);
          } else {
            this.showMessage('Failed to update renderer pool');
          }
        })
        .catch(error => {
          console.error('Error updating renderer pool:', error);
          this.showMessage('Error updating renderer pool');
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }

  cancel(): void {
    this.dialogRef.close();
  }

  private showMessage(message: string): void {
    this.snackBar.open(message, 'OK', { duration: 3000 });
  }
}